"use client";

import React, { useState } from "react";
import { useRouter, usePathname } from "next/navigation";
import WhoToFollow from "@/components/WhoToFollow";
import SearchComponent from "./search/SearchComponent";
import PopularUser from "@/components/PopularUser";
import { useQuery } from "@apollo/client";
import { GET_NOTIFICATIONS_COUNT } from "@/api/apollo-client/queries/Queries";
import LoginForm from "@/components/auth/LoginForm";
import VideoPlayer from "./Posts/VideoPlayer";
import TrendingTagsClient from "./TrendingTagsRightSidebar/TrendingTagsClient";
import { userAgent } from "next/server";
import { useAuth } from "@/contexts/authContext";

const Sidebar = () => {
  const router = useRouter();
  const { user } = useAuth();
  const pathname = usePathname();
  const [isSearchActive, setIsSearchActive] = useState(false);
  const { isAuthenticated } = require("@/contexts/authContext").useAuth();
  const { data } = useQuery(GET_NOTIFICATIONS_COUNT, {
    skip: !isAuthenticated,
    pollInterval: 30000, // Poll every 30 seconds
  });

  if (pathname?.includes("/marketplace") || pathname?.includes("/elections")) {
    return null;
  }
  if (!isAuthenticated) {
    return (
      <div className="backdrop-blur-3xl">
        <aside className="hidden md:block h-screen w-[24vw] border-l border-white/75 dark:border-white/25 bg-white/25 dark:bg-white/10 shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[1.9px] rounded-2xl text-[#020817] dark:text-[#F8FAFC] sticky top-0 overflow-y-auto">
          <div className="h-full flex items-center justify-center pb-16">
            <LoginForm redirectTo={pathname || "/"} />
          </div>
        </aside>
      </div>
    );
  }

  return (
    <div className="backdrop-blur-3xl ">
      <aside className="hidden md:block h-screen w-[24vw]  border-l border-white/75 dark:border-white/25 bg-white/25 dark:bg-white/10 shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[1.9px] rounded-2xl text-[#020817] dark:text-[#F8FAFC] sticky top-0 overflow-y-auto">
        <div className="h-full flex flex-col gap-2 p-4">
          <div className="bg-white/25 dark:bg-white/10 rounded-2xl border border-white/75 dark:border-white/25 shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[1.9px] p-4 ">
            <div className="bg-white/40 dark:bg-white/20 rounded-full shadow-sm backdrop-blur-sm hover:bg-white/60 dark:hover:bg-white/30 transition-colors">
              <SearchComponent />
            </div>
          </div>
          {!isSearchActive && (
            <>
              <WhoToFollow />

              {/* Trending Tags */}
              <div className="bg-white/25 dark:bg-white/10 rounded-2xl border border-white/75 dark:border-white/25 shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[1.9px]">
                <TrendingTagsClient />
              </div>
            </>
          )}
        </div>
      </aside>
    </div>
  );
};

export default Sidebar;
